var _path, _ellipse, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChurch6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 1080,
    viewBox: "0 0 1920 1080",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M255 114L255 142",
    stroke: "#F2DCCE",
    strokeWidth: 2
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 255.5,
    cy: 109.333,
    rx: 16.5,
    ry: 16.3333,
    fill: "#F2DCCE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M250.987 109.19C250.987 105.283 254.288 102.117 258.358 102.117C258.943 102.117 259.511 102.184 260.056 102.308C258.742 101.48 257.187 101 255.519 101C250.814 101 247 104.806 247 109.5C247 114.194 250.814 118 255.519 118C257.814 118 259.895 117.093 261.427 115.62C260.492 116.032 259.454 116.263 258.358 116.263C254.288 116.263 250.987 113.096 250.987 109.19Z",
    fill: "#CC7D61"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M264.402 108.6L264.37 106.146L262.536 107.719L260.304 107.056L261.112 109.337L259.765 111.381L262.1 111.218L263.499 113.144L264.133 110.763L266.345 109.909L264.402 108.6Z",
    fill: "#CC7D61"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChurch6);
export default __webpack_public_path__ + "static/media/church_6.d03a44423a600208cadcecc6a15ba4f9.svg";
export { ForwardRef as ReactComponent };